export default async function logged({next, app}){
  let c = app.config.globalProperties;

  // Check if state dont have
  if (!c.$store.state.auth.user) {
    return next('/signin');
  }

  next();
};